module.exports = __webpack_public_path__ + "static/media/orange.42ffbc6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/partners/orange.png
// module id = 256
// module chunks = 0